import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../../utils";
import { app_env } from "../../../utils";

export const useStyles = makeStyles((theme, data) => ({
  notificationFlex: {
    display: "flex",
    alignItems: "center",
    backgroundColor: data?.is_read === true ? '#fff' : theme?.palette?.notification?.secondary,
    padding: "12px",
    borderBottom: `1px solid ${theme?.palette?.background?.secondary}`,
    position: "relative",
    cursor: 'pointer',
  },
  bellBackGroundColor: {
    backgroundColor: theme?.palette?.notification?.primary,
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    marginRight: "10px",
  },
  tabs: {
    "&.MuiTab-root": {
      padding: "0px !important",
    },
  },
  notification: {
    cursor: "pointer"
  },
  title: {
    color: theme?.typography?.color?.primary,
    fontFamily: FontFamilySwitch().bold,
    fontSize: "0.75rem",
    marginBottom: '1px',
    maxWidth: '223px',
    width: '100%',
    '& p': {
      margin: '0px 0px 4px !important'
    },
    '& .ql-editor': {
      padding: '0px 0px 0px 0px',
      fontSize: "0.875rem",
      maxWidth: '223px',
      width: '100%',
      cursor: 'pointer'
    },
    '& .ql-editor > *': {
      fontSize: "0.875rem",
    }
  },
  date: {
    color: theme?.typography?.color?.tertiary,
    fontFamily: FontFamilySwitch().regular,
    fontSize: "0.75rem",
  },
  des: {
    color: theme?.typography?.color?.tertiary,
    fontFamily: FontFamilySwitch().regular,
    fontSize: "0.75rem",
    marginBottom: '1px',
    cursor: 'pointer',
    '& p': {
      margin: '0px 0px 4px !important'
    },
    '& .ql-editor': {
      padding: '0px 0px 0px 0px',
      maxWidth: '223px',
      width: '100%',
      color: theme?.typography?.color?.tertiary,
      fontFamily: FontFamilySwitch().regular,
      fontSize: "0.75rem !important",
      marginBottom: '1px',
    },
    '& .ql-editor > *': {
      fontSize: "0.75rem !important",
    }
  },
  chip: {
    borderRadius: theme?.palette?.borderRadius,
    color: theme?.palette?.notification?.chip,
    backgroundColor: theme?.palette?.background?.chip,
    position: "absolute",
    padding: "0px",
    width: "71px",
    height: "21px",
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().regular,
    top: '7px',
    right: '6px',
    "&:hover": {
      color: theme?.palette?.notification?.chip,
      backgroundColor: theme?.palette?.background?.chip,
    },
  },
  IconBackGroundColor: {
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    marginRight: "10px",
  },
}));
export const useStylesTopNavBar = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  switcher: {
    borderRadius: theme.palette.borderRadius,
    padding: "4px 16px",
  },
  menu: {
    marginTop: "14px",
    left: "14px",
    "& .css-1poimk-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper":
    {
      borderRadius: theme.palette.borderRadius,
      padding: "0px !important",
      boxShadow: "0px 8px 24px #0717411F",
    },
    "& .MuiMenu-list": {
      padding: "0 !important",
    },
  },
  menu2: {
    marginTop: "4px",

    "& .css-1poimk-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper":
    {
      borderRadius: theme.palette.borderRadius,
      padding: "0px !important",
      boxShadow: "0px 8px 24px #0717411F",
    },
    "& .MuiMenu-list": {
      padding: "0 !important",
    },
  },
  borders: {
    padding: "8px 0px",
    //borderBottom: "1px solid #E4E8EE",
  },
  appBar: {
    backgroundColor: "white",
    boxShadow: "none",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
    },
    // eslint-disable-next-line
    boxShadow: (props) => (props?.boxShadow === false ? "none" : "auto"),
  },
  app_bar_grid: {
    backgroundColor: "#232323",
    borderBottom: "1px solid #666666",
    boxShadow: "none",
    maxWidth: "1920px",
  },
  toolbar: {
    width: "inherit",
  },
  toolbar_stack: {
    width: "inherit",
  },
  tag: {
    border: "1px solid #F17360",
    color: "#F17360",
    padding: "2px 4px",
    borderRadius: theme.palette.borderRadius,
    display: "inline",
    fontSize: "0.75rem",
    marginTop: "4px",
  },
  moduleNametag: {
    border: "1px solid #E4E8EE",
    color: "#FFFFFF",
    padding: "2px 4px",
    borderRadius: theme.palette.borderRadius,
    display: "inline",
    fontSize: "0.875rem",
    fontFamily: FontFamilySwitch().semiBold,
  },
  title: {
    display: "block",
    color: "#FFFFFF",
    fontSize: "1rem",
    fontFamily: FontFamilySwitch().bold,
    [theme.breakpoints.down("md")]: {
      fontSize: "0.9375rem",
    },
  },
  userimg: {
    borderRadius: "50%",
    height: "65px",
    width: "65px",
  },
  titleLogo: {
    textTransform: "capitalize",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  logo: {
    objectFit: "contain",
    cursor: "pointer",
    marginInlineEnd: "8px",
    borderRadius: theme.palette.borderRadius
  },
  titleLogo2: {
    cursor: "pointer",
    textTransform: "capitalize",
    marginInlineEnd: "12px",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  border1: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    display: "flex",
    alignItems: "center",
    backgroundColor: "#E4E8EE",
  },
  menuIcon: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  gotocomm: {
    marginLeft: "8px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    // padding:'11px 11px 0px 0px'
  },
  language: {
    border: "1px solid #707070",
    color: "#FFFFFF",
    padding: "0px 6px!important",
    "&:hover": {
      backgroundColor: "inherit"
    }
    // padding:'11px 11px 0px 0px'
  },
  username: {
    color: "#FFFFFF",
    // marginLeft: "8px",
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    cursor: "pointer",
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().bold,
  },
  username1: {
    color: theme.typography.color.primary,
    fontSize: "0.875rem",
    fontFamily: FontFamilySwitch().bold,
  },
  email: {
    color: theme.typography.color.tertiary,
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().regular,
    margin: "6px 0px"
  },
  username2: {
    color: "#98A0AC",
    marginLeft: "8px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "0.75rem",
  },
  arrow: {
    marginLeft: "8px",
  },
  titleContainer: {
    [theme.breakpoints.up("md")]: {
      marginLeft: theme.spacing(2),
    },
    display: "flex",
    alignItems: "center",
  },
  user: {
    display: "flex",
    alignItems: "center",
  },
  border: {
    display: "flex",
    alignItems: "center",
    color: "#FFF",
  },
  titlerole: {
    color: theme.typography.color.tertiary,
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().bold,
    margin: "8px 8px 4px 8px",
  },
  roleData: {
    borderRadius: "12px",
    border: "1px solid #E4E8EE",
    padding: "8px",
    minHeight: "110px",
    cursor: "pointer",
  },
  avatarrole: {
    marginTop: "4px",
  },
  labelrole: {
    fontSize: "0.75rem",
    color: theme.typography.color.primary,
    fontFamily: FontFamilySwitch().semiBold,
    marginTop: "4px",
  },
  label: {
    fontSize: "0.8125rem",
    color: theme.typography.color.secondary,
    fontFamily: FontFamilySwitch().semiBold,
    padding: "6px 12px",
    cursor: "pointer",
  },
  label2: {
    fontSize: "0.8125rem",
    color: "#FF4B4B",
    fontFamily: FontFamilySwitch().semiBold,
    padding: "6px 12px",
    cursor: "pointer",
  },
  signout: {
    color: "#FF4B4B",
    fontSize: "0.875rem",
    padding: "12px 12px 8px 20px",
    marginTop: "12px",
    cursor: "pointer",
    borderTop: "1px solid #E4E8EE",
  },
  versionCss: {
    color: "#aeaeaebd",
    fontSize: "0.75rem",
    position: "absolute",
    bottom: "5px",
    left: "70px",
  },
  switchBtn: {
    backgroundColor: "#5078E1",
    color: "#fff",
    width: "100%",
    marginTop: "4px",
    "&:hover": {
      backgroundColor: "#5078E1",
      color: "#fff",
    },
  },
  switchParent: {
    backgroundColor: "#F2F3F5",
    borderRadius: "4px",
    padding: "12px",
  },
  switchName: {
    color: "#4E5A6B",
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().semiBold,
    marginLeft: "10px",
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "12px",
  },
  lostLogin: {
    color: "#98A0AC",
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().regular,
  },
  profileCard: {
    borderTop: "1px solid #F2F3F5",
    borderBottom: "1px solid #F2F3F5",
    padding: "7px 16px",
  },
  anchor: {
    color: "#98A0AC",
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().regular,
    textDecoration: "underline",
    cursor: "pointer",
  },
  dot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: "#E4E8EE",
    margin: "0px 10px",
    padding: "3px",
  },
  Reference: {
    padding: "14px 16px",
  },
  popupBoady: {
    padding: "0px 24px",
    marginBottom: "10px"
  },
  notification: {
    color: "#fff",
  },
  notificationBox: {
    width: "400px",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  accordion: {
    "&.MuiAccordion-root:before": {
      backgroundColor: theme.palette.background.tertiary
    },
    backgroundColor: theme.palette.background.tertiary,
    "&.MuiAccordion-root:last-of-type": {
      // borderBottomRightRadius: "12px",
      // borderBottomLeftRadius: "12px"
    },
    "&.MuiAccordion-root:first-of-type": {
      // borderTopRightRadius: "12px",
      // borderTopLeftRadius: "12px"
    },
    "&.Mui-expanded": {
      backgroundColor: theme.palette.background.tertiary,
    }
  },
  text: {
    fontFamily: FontFamilySwitch().bold,
    fontSize: "1rem",
    color: theme.typography.color.primary,
    margin: "10px"

  },
  helpText: {
    fontFamily: FontFamilySwitch().semiBold,
    fontSize: "0.75rem",
    color: theme.typography.color.secondary,
    textDecoration: "none"
  },
  accordionBox: {
    backgroundColor: theme.palette.background.tertiary,

  },
  loader: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px'
  },
  textButton: {
    cursor: "pointer",
    color: "white",
    fontSize: "0.875rem",
    fontFamily: FontFamilySwitch().semiBold,
    marginInlineStart: "8px",
    marginInlineEnd: "8px"
  },
  divider: {
    backgroundColor: "white",
    height: "23px"
  },
  env_tag: {
    borderRadius: "2px",
    padding: "1px 6px",
    backgroundColor: (props) => app_env(props?.app_Env)?.tag_color,
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().bold,
    color: "white",
    marginInlineStart: "12px",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  nodataFound: {
    fontSize: "0.875rem",
    color: theme.typography.color.secondary,
    fontFamily: FontFamilySwitch().semiBold,
  }
}));
